/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @angular-eslint/component-selector */
import { Component, OnInit, Input, Output, EventEmitter, Inject, Optional } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../../api.service';
import { ToastrService } from 'ngx-toastr';
declare const $: any;
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { emailPattern, noWhitespaceInRequiredValidator, mobilePattern, convertToNgbDate, datePickerMinDate, allowedLogoFiles } from '../../../shared/constants';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { environment } from '../../../../environments/environment';
import { NavbarComponent } from '../../../navbar/navbar.component';

@Component({
	selector: 'doctor-form',
	templateUrl: './doctor-form.component.html',
	styleUrl: './doctor-form.component.scss'
})
export class DoctorFormComponent implements OnInit {
	moduleForm!: FormGroup;
	showLoader = false;
	pageLoading1 = false;
	pageLoading2 = false;
	pageLoading3 = false;
	pageLoading4 = false;
	@Input() uId: any = null;
	@Input() type: any = null;
	@Output() created = new EventEmitter<any>();
	@Output() cleared = new EventEmitter<any>();
	customError: any = {};
	formSubmitted = false;
	countryCodes: any = [];
	hospitalList: any = [];
	userTypes: any = [];
	fileMsg1: any[] = [];
	file1!: File;
	fileMsg2: any[] = [];
	file2!: File;
	fileMsg3: any[] = [];
	file3!: File;
	allowedLogoFiles = allowedLogoFiles;
	minDate = datePickerMinDate;
	maxDate = convertToNgbDate(new Date());
	docDetails: any = null;
	File_Storage_URL = environment.File_Storage_URL;

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) {
		this.moduleForm = this.formBuilder.group({
			name: [null, [Validators.required, noWhitespaceInRequiredValidator]],
			type_id: [null, [Validators.required, noWhitespaceInRequiredValidator]],
			licence_no: [null],
			country_code: [null, [Validators.required, noWhitespaceInRequiredValidator]],
			phone_number: [null, [Validators.required, noWhitespaceInRequiredValidator, Validators.pattern(mobilePattern)]],
			email: [null, [Validators.required, noWhitespaceInRequiredValidator, Validators.pattern(emailPattern)]],
			licence_authority: [null],
			licence_date: [null],
			dg_no: [null],
			qualification: [null],
			hospitals: [[]],
			consultation_charges: [null, [Validators.pattern(/^[+-]?([0-9]*[.])?[0-9]+$/)]]
		});
	}

	get f() { return this.moduleForm.controls; }

	ngOnInit(): void {
		this.getCountryCodes();
		this.getHospitalList();
		this.getUserTypes();
		if (this.uId) {
			this.getDetails();
		}
		if (this.type) {
			this.f.type_id.setValue(this.type);
		}
	}

	getCountryCodes() {
		this.pageLoading4 = true;
		this.apiService.countryCodes().subscribe({
			next: (data: any) => {
				data.map((c: any) => {
					c.display = c.dial_code + "(" + c.name + ")"
					return c;
				})
				this.countryCodes = data;
				this.pageLoading4 = false;
			}, error: () => {
				this.countryCodes = [];
				this.pageLoading4 = false;
			}
		});
	}

	getHospitalList() {
		this.pageLoading3 = true;
		this.apiService.getHospital({}).subscribe({
			next: (data: any) => {
				this.hospitalList = data.data;
				this.pageLoading3 = false;
			}, error: () => {
				this.hospitalList = [];
				this.pageLoading3 = false;
			}
		});
	}

	getUserTypes() {
		this.pageLoading2 = true;
		this.apiService.getUserTypes({}).subscribe({
			next: (data: any) => {
				this.userTypes = data;
				this.pageLoading2 = false;
			}, error: () => {
				this.userTypes = [];
				this.pageLoading2 = false;
			}
		});
	}

	clearForm() {
		this.moduleForm.reset();
		this.cleared.emit();
	}

	getDetails() {
		this.pageLoading1 = true;
		this.apiService.getDoctor({ id: this.uId }).subscribe({
			next: (data: any) => {
				this.docDetails = data.data;
				this.moduleForm.setValue({
					name: this.docDetails.name,
					licence_no: this.docDetails.licence_no,
					type_id: this.docDetails.type,
					country_code: this.docDetails.country_code,
					phone_number: this.docDetails.phone_number,
					email: this.docDetails.email,
					licence_authority: this.docDetails.licence_authority,
					licence_date: this.apiService.getDateFromDateString(this.docDetails.licence_date),
					dg_no: this.docDetails.dg_no,
					qualification: this.docDetails.qualification,
					consultation_charges: this.docDetails.consultation_charges,
					hospitals: this.docDetails.hospitals.map((hosp) => hosp.id)
				});
				this.pageLoading1 = false;
			}, error: (error) => {
				this.pageLoading1 = false;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) {
				}
			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required fields", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		const formData = new FormData();
		formData.append("name", this.f.name.value || "");
		formData.append("licence_no", this.f.licence_no.value || "");
		formData.append("type_id", this.f.type_id.value || "");
		formData.append("country_code", this.f.country_code.value || "");
		formData.append("phone_number", this.f.phone_number.value || "");
		formData.append("email", this.f.email.value || "");
		formData.append("licence_authority", this.f.licence_authority.value || "");
		formData.append("licence_date", this.apiService.getDateStringFromDate(this.f.licence_date.value) || "");
		formData.append("dg_no", this.f.dg_no.value || "");
		formData.append("consultation_charges", this.f.consultation_charges.value || "");
		formData.append("qualification", this.f.qualification.value || "");
		let hospitals: any[] = [];
		try {
			hospitals = this.f.hospitals.value.map((hosp) => { return { id: hosp } });
		} catch (error) { }
		formData.append("hospitals", JSON.stringify(hospitals));
		if (this.file1) {
			formData.append("stamp", this.file1);
		}
		if (this.file2) {
			formData.append("signature", this.file2);
		}
		if (this.file3) {
			formData.append("stamp_with_signature", this.file3);
		}
		if (this.uId) {
			formData.append("id", this.uId);
		}
		this.showLoader = true;
		this.apiService.createUpdateDoctor(formData).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.created.emit(data);
				this.clearForm();
			}, error: (error) => {
				this.showLoader = false;
				if (error.status == 401) { return }
				let errorMsg = "Something went wrong.";
				if (typeof error.error == "string") {
					errorMsg = error.error;
				}
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}

	public onFileSelect1(file) {
		this.file1 = file;
	}

	public onFileSelect2(file) {
		this.file2 = file
	}

	public onFileSelect3(file) {
		this.file3 = file
	}
}
